const AccountGetter = {
    accountDetails: (state) => state.accountDetails,
    groups: (state) => state.groups,
    account: (state) => state.account,
    settings: (state) => state.settings,
    profile: state => state.profit
};

export default AccountGetter;